import { Injectable } from '@angular/core';
import { State, Action, StateContext } from '@ngxs/store';
import {
  ScreeningStateModel,
  SetPostalCode,
  SetTrade,
  SetRecording,
  SetHasDivergenceReport,
  UpdateReappraisal,
  SetQuestionsDynamic,
} from './screening.actions';
import { ScreeningService } from './screening.service';

@State<ScreeningStateModel>({
  name: 'screening',
  defaults: {
    postalCode: '',
    idTrade: '',
    originalIMEI: '',
    idOperation: '',
    idSubCategory: '',
    screeningStep: '',
    hasDivergenceReport: false,
    isReappraisal: false,
    reasonOfReappraisal: '',
  },
})
@Injectable()
export class ScreeningState {
  constructor(private _screeningService: ScreeningService) {}

  @Action(SetPostalCode)
  setPostalCode({ patchState }: StateContext<ScreeningStateModel>, { payload }: SetPostalCode) {
    patchState({
      postalCode: payload,
    });
  }

  @Action(SetTrade)
  setTrade({ patchState }: StateContext<ScreeningStateModel>, { payload }: SetTrade) {
    patchState(payload);
  }

  @Action(SetHasDivergenceReport)
  setHasDivergenceReport(
    { patchState }: StateContext<ScreeningStateModel>,
    { payload }: SetHasDivergenceReport
  ) {
    patchState({ hasDivergenceReport: payload });
  }

  @Action(UpdateReappraisal)
  updateReappraisal(
    { patchState }: StateContext<ScreeningStateModel>,
    { payload }: UpdateReappraisal
  ) {
    patchState({
      isReappraisal: payload.isReappraisal,
      reasonOfReappraisal: payload.reasonOfReappraisal,
    });
  }

  @Action(SetQuestionsDynamic)
  setQuestionsDynamic(
    { patchState }: StateContext<ScreeningStateModel>,
    { payload }: UpdateReappraisal
  ) {
    patchState(payload);
  }
}
